/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 28/3/2023
 */

import { useState } from "react";
import usePagination from "../Hooks/usePagination";

 export const PaginationDetails = (data) => {
    let [page, setPage] = useState(1);
    const PER_PAGE = 8;

    const _DATA = usePagination(data, PER_PAGE);

    const count = Math.ceil(data?.length / PER_PAGE) || 0;
    
    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
    };

    return { page, count, handleChange, _DATA };
};